$(document).ready(function(){

    $(window).scroll(function(){
        var navbar = $('.navbar');
        var scroll = $(window).scrollTop();

        if (scroll >= 100) navbar.addClass('is-compact');
        else navbar.removeClass('is-compact');
    });


    if(detectmob()) {
        $('.hero').css("background-attachment", "scroll");
    }else{
        $('.hero').css("background-attachment", "fixed");
    }
});


var $scrollElem = $('.arrow-cube');
$scrollElem.click(function () {
    $('html, body').animate({
        scrollTop: 0
    });

    return false;
});

function detectmob() {
    if( navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
    ){
        return true;
    }
    else {
        return false;
    }
}